<script>
import * as acessotela from '@/api/acessotela'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  data () {
    return {
      title: 'Listar Acesso Tela',
      modal: {
        component: 'app-acessotela-edit',
        width: 300,
        field: 'descricao'
      },
      backend: acessotela
    }
  }
}
</script>

<template>
  <simple-crud-grid :title="title" :mode="mode" :modal="modal" :backend="backend" @save="(data) => $emit('save', data)" />
</template>
